import { type HTMLAttributes, useState } from 'react';
import type { ChipsMetadata } from 'autogen/swagger/comai';
import { CHAT_ENTRY_DRAWER_ID } from 'components/chat/ChatEntry';
import useDrawer, { openDrawers } from 'components/generic/Drawer/hooks/useDrawer';
import FlexRow from 'components/Layout/components/Flex/components/FlexRow';
import { COM_AI_DRAWER_ID } from '../shared/consts';
import { sendMessage } from '../shared/helpers';
import { AIIcon } from '../shared/styles';
import type { UserMessageContext } from '../shared/types';
import Chip from './Chip';

type BasicChipsProps = HTMLAttributes<HTMLDivElement> & {
    chips: ChipsMetadata['chips'];
    context?: UserMessageContext;
    children?: React.ReactNode;
    hideWhenClicked?: boolean;
    showAIIcon?: boolean;
};

export default function BasicChips(props: BasicChipsProps) {
    const { chips, context, children, hideWhenClicked, className, showAIIcon } = props;
    const [clicked, setClicked] = useState(false);
    const comAIDrawer = useDrawer(COM_AI_DRAWER_ID, { disableOverlay: true });

    if (hideWhenClicked && clicked) {
        return null;
    }

    async function handleClick(query: string) {
        const { isOpen } = comAIDrawer;

        if (!isOpen) {
            await openDrawers([
                { id: CHAT_ENTRY_DRAWER_ID, props: { disableOverlay: true } },
                { id: COM_AI_DRAWER_ID, props: { disableOverlay: true } }
            ]);
        }

        sendMessage(query, context);
        setClicked(true);
    }

    return (
        <FlexRow gap="8px" wrap="wrap" alignItems="center" className={className}>
            {showAIIcon && <AIIcon type="AI" size={24} fill="white" />}
            {chips.map(({ text, query }, i) => {
                return (
                    <Chip
                        key={i}
                        onClick={() => {
                            handleClick(query);
                        }}
                    >
                        {text}
                    </Chip>
                );
            })}
            {children}
        </FlexRow>
    );
}
